import styled from "styled-components";
import {Tabs} from "@material-ui/core";

export const Root = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: 8px;
    .rowrow {
        grid-auto-columns: max-content 1fr 1fr;
        gap: 1rem;
    }
    .export-col {
        place-self: end;
    }
`;

export const TabsStyled = styled(Tabs)`
    &.MuiTabs-root {
        border-bottom: 1px solid #cfcfcf;
        min-height: 43px;
        height: 43px;
        margin-bottom: 10px;
    }
    .MuiTab-root {
        font-size: 14px;
        font-weight: 600;
        min-width: auto;
        text-transform: capitalize;
    }
`;
